import React, { createContext, useContext, useState } from "react";

const defaultLanguage = { id: 1, languageText: "Svenska" };
export const LanguageContext = createContext();

/**
 * Custom hook to use the LanguageContext.
 * 
 * @returns {object} The current language context value.
 * @throws Will throw an error if used outside of a LanguageProvider.
 */
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    // Make sure to wrap the parent component with the LanguageProvider in order to make use of the langauge context in the descending child nodes
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}


/**
 * LanguageProvider component that provides the language context to its children.
 * 
 * @param {React.ReactNode} children - The child components that will receive the language context.
 * @returns {JSX.Element} The language provider component with context.
 */
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(defaultLanguage);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
